import React from 'react';
import ReactDOM from 'react-dom';
import './leptons.css';
import './i18n';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { RecoilRoot } from 'recoil';
import axios from 'axios';
import { ReCaptchaProvider } from 'react-recaptcha-x';
import { reCaptchaKeyV2, reCaptchaKeyV3 } from './Consts';

axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.withCredentials = true

ReactDOM.render(
  <React.StrictMode>
    <ReCaptchaProvider
      siteKeyV2={reCaptchaKeyV2}
      siteKeyV3={reCaptchaKeyV3}
      langCode="en"
      hideV3Badge={true}>
      <RecoilRoot>
        <App />
      </RecoilRoot>
    </ReCaptchaProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
